import { useEffect, useState } from 'react';
import { css } from '@emotion/react'

import styled from '@emotion/styled'
import EditForm from '../../utils/utilities/EditForm';

import { DateTime } from 'luxon';

import { nanoid } from 'nanoid';

import { fields, initialValues, schema, additionalState, parseData } from './config';

import ShoppingCartCheckoutRoundedIcon from '@mui/icons-material/ShoppingCartCheckoutRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';

import Sidebar from './Components/Sidebar';

import { UrlParamsContext } from '../../contexts/UrlParams';


const EditCheckout = ({ invalidateQueries = []}) => {

  const [formFields, setFormFields] = useState([...fields.map(field => ({...field}))]);

  const [url_params, setUrlParams] = useState("checkout");

  const [initValues, setInitValues] = useState({...initialValues, date: DateTime.now(), due_date: DateTime.now(), checkout_id: nanoid(8)});

  let invoice_id = url_params.split('/')?.[2]; // workaround to get edit_id to refresh from backend after edit

   const additionalButtons = url_params === "checkout" ? [
    { text: "Checkout without Payment", variant: "outlined", color: "primary", icon: <ShoppingCartCheckoutRoundedIcon />, forceClose: true},
    { text: "Continue to Payment", variant: "contained", color: "primary", icon: <ArrowForwardRoundedIcon />}
  ] : [{ text: "Checkout", variant: "contained", color: "primary", icon: <ShoppingCartCheckoutRoundedIcon />, forceClose: true}]
  
  return (
    <UrlParamsContext.Provider value={{url_params, setUrlParams}}>
      <EditForm 
        title={"Checkout"} 
        initialValues={initValues} 
        fields={formFields} 
        schema={schema} 
        url={"invoices"} 
        url_params={{post: url_params}} 
        sidebar={<Sidebar />} 
        additionalState={additionalState} 
        dialog={true} 
        keep_open={true} 
        collection_id="invoice_id" 
        parseData={parseData}
        additionalButtons={additionalButtons} 
        edit_id={invoice_id} 
        submitButton={true}
        ignore_id={true} 
        invalidate_queries={[["appointments"], ...invalidateQueries]}
      >
      </EditForm>
    </UrlParamsContext.Provider>
  );
}

export default EditCheckout;